import { render, staticRenderFns } from "./BasicEduIT.vue?vue&type=template&id=ef5b5e6e"
import script from "./BasicEduIT.vue?vue&type=script&lang=js"
export * from "./BasicEduIT.vue?vue&type=script&lang=js"
import style0 from "./BasicEduIT.vue?vue&type=style&index=0&id=ef5b5e6e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports